import axiosInstance from './axiosInstance';

// Get all tasks
export const getTasks = () => axiosInstance.get('/api/dashboard/tasks');

// Get a single task by ID
export const getTask = (id) => axiosInstance.get(`/api/dashboard/tasks/${id}`);

// Create a new task
// data should include: title, description, dueDate, propertyId, contactId, assignedUserId (optional)
export const createTask = (data) => axiosInstance.post('/api/dashboard/tasks', data);

// Update an existing task
// data can include: title, description, dueDate, propertyId, contactId, assignedUserId
export const updateTask = (id, data) => axiosInstance.put(`/api/dashboard/tasks/${id}`, data);

// Delete a task
export const deleteTask = (id) => axiosInstance.delete(`/api/dashboard/tasks/${id}`);
